// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@5.90.3/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".report-c[data-v-768cc6db] {\n  cursor: pointer;\n}\n.report-c .img-hover[data-v-768cc6db] {\n  display: none;\n}\n.report-c:hover .img-hover[data-v-768cc6db] {\n  display: inline-block;\n}\n.report-c:hover .img-default[data-v-768cc6db] {\n  display: none;\n}\n.report-c .report[data-v-768cc6db] {\n  color: #606060;\n}\n.report-c .report[data-v-768cc6db]:hover {\n  color: #111;\n}\n", ""]);
// Exports
module.exports = exports;
